import { useLayoutSelectors } from 'services/layout';
import { useUserSelectors } from 'services/user';
import { TopMenu } from './TopMenu';

export const ConnectedTopMenu = () => {
  const { isMobile } = useLayoutSelectors();
  const { user } = useUserSelectors();
  return <TopMenu user={user} isMobile={isMobile || false} />;
};
